import { useRef, useState } from "react"
import { _, parseNum } from "../../utils/helpers"
import { Icon } from "../../parts/Icon"
import { booking } from "../../utils/symbols"

export const AsideSummary = () => {

    const [open, setOpen] = useState(false)
    const content = useRef<HTMLDivElement>(null)

    return (
        <div className={`aside-summary-container w-100 ${open ? "open" : ""}`}>
            <button 
                className="df jcsb aic aside-summary-trigger w-100"
                onClick={() => setOpen(x => !x)}
            >
                <span className="text s18-600">
                    {_("0ge_summa__")}
                </span>
                <Icon icon="chevron"/>
            </button>
            <div 
                ref={content}
                className="aside-summary-content pt-5"
                style={{
                    maxHeight: `${open ? "unset" : "0px"}`,
                    overflow: "hidden",
                }}
            >
            {
                booking.products.map(product => {

                    return (
                        <p className="df aic jcsb aside-summary-content-item text" key={product.productId}>
                            <span>{product.name} x{product.qty}</span>
                            <span>{parseNum("EUR", product.price)}</span>
                        </p>
                    )
                })
            }
            </div>
        </div>
    )
}